import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class PromotionService {

  constructor(private dataService: DataService) { }

  savePromotion(savePromotion: string) {
    return this.dataService.post('/api/promotion/savePromotion', savePromotion);
  }

  getPromotions(SearchQuery: string) {
    return this.dataService.getRecordWithParams('/api/promotion/getPromotions', SearchQuery);
  }

  getPromotionById(promotionId: number) {
    return this.dataService.getRecord('/api/promotion/getPromotionById/' + promotionId);
  }

  deletePromotion(promotionId: number) {
    return this.dataService.delete('/api/promotion/deletePromotion/?promotionId=' + promotionId);
  };
}
